import {
    CHANGE_DOMAIN_TYPE,
    DOMAIN_CLEARED,
    DOMAIN_SELECTED
} from './types/domain-selector-action-types';

import MimirService from '../../common/services/mimir-service';
import { updateQueryParam } from '../../utils/query-param-utils';

export function searchDomains( params ){
    return ( dispatch, getState, { DATA_API } ) => {
        const api = new MimirService( DATA_API );

        return api.getApprovedDomains( params );
    };
}

export function selectDomain( params ){
    return ( dispatch ) => {
        const { namespace, domain } = params;
        updateQueryParam( { domain } );
        dispatch ( {
            domain,
            namespace,
            type: DOMAIN_SELECTED,
        } );
    };
}

export function clearDomain( params ){
    return ( dispatch ) => {
        const { namespace } = params;
        updateQueryParam( { domain: undefined } );

        dispatch ( {
            namespace,
            type: DOMAIN_CLEARED,
        } );
    };
}

export function changeDomainType( params ){
    const { domainType, namespace } = params;
    updateQueryParam( { domainType } );

    return {
        domainType,
        namespace,
        type: CHANGE_DOMAIN_TYPE,
    };
}
